import { Component, OnInit } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { LabelService } from '../_services/label.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditLabelComponent } from './editlabel/editlabel.component';

@Component({
  selector: 'app-home',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.css']
})
export class ChangelogComponent implements OnInit {

  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  labels: any[] = [];
  public breadcrumb: any;
  search: any;
  accepted: string="1";
  options = {
    close: true,
    expand: true,
    minimize: true,
    reload: true
  };
  page=1;
  constructor(
    private labelService: LabelService,
    private modal: NgbModal
  ) { }


  openEditModal(data:any){
    const modalref=  this.modal.open(EditLabelComponent, { size: 'lg' });
    modalref.componentInstance.label=data;
    modalref.result.then((result)=>{
      this.getLabels();
    });
    }



  getLabels() {
    console.log(this.accepted);
    this.labelService.getLabelspage(this.page,this.accepted).subscribe(res => {
      
      this.labels = res;
    });
  }

  ngOnInit() {
    console.log("ngOnInit");
    this.getLabels();
  }

  reloadChangelog() {
    this.blockUIChangelog.start('Loading..');

    setTimeout(() => {
      this.blockUIChangelog.stop();
    }, 2500);
  }

   prev(){
    if(this.page>1)
      this.page--;
    this.getLabels();

  }

    next(){
      this.page++;
      this.getLabels();
    
  }

    ara(){
     if(this.search==""){
      this.getLabels();
 
     }
     else{

    
      this.labelService.ara(this.search).subscribe(res=>{
          this.labels=res;
      });
       }
  }
}
